// This must be the first import in main-entry.js.
// ES module imports are hoisted, so no code in main-entry.js
// runs before imports evaluate. This ensures window.CC_CONSTANTS
// is defined for all subsequent imports.
//
// CC_CONSTANTS.isNonWp is set here to indicate that JS has been
// loaded without wp_localize_script (search.champlain.edu). 
// This allows us to make sure debug output is off, and no 
// alertsapi requests are made to the current host/domain (since
// those endpoints only exist for core-composer WP installs).
window.CC_CONSTANTS = window.CC_CONSTANTS ?? {isNonWp: true};